<form (ngSubmit)="save()" [formGroup]="form" class="grid grid-cols-12" novalidate>
  <app-form-number-input
    [form]="form"
    [maxFractionDigits]="0"
    [min]="0"
    id="externalIdType"
    label="MAPPING_CATALOGS.EPIC_EXPORT_EXTERNAL_ID_TYPE"></app-form-number-input>

  <app-form-number-input
    [form]="form"
    [maxFractionDigits]="0"
    [min]="0"
    id="startId"
    label="MAPPING_CATALOGS.EPIC_EXPORT_START_ID"></app-form-number-input>

  <app-form-text-input
    [form]="form"
    [maxLength]="blockedIdsMaxChars"
    [textArea]="true"
    ariaDescribedBy="blockedIdsHint"
    id="blockedIdsRaw"
    label="MAPPING_CATALOGS.EPIC_EXPORT_BLOCKED_IDS"></app-form-text-input>

  <div class="col-span-12 text-sm text-color-secondary mb-2" id="blockedIdsHint">
    {{ 'MAPPING_CATALOGS.EPIC_EXPORT_BLOCKED_IDS_HINT' | translate }}
  </div>
</form>

<div class="mt-2">
  <p-button
    (onClick)="save()"
    [disabled]="form.invalid"
    [label]="'ACTIONS.SAVE' | translate"
    icon="fal fa-save"
    styleClass="mr-2"
    type="button"></p-button>
  <p-button
    (onClick)="cancel()"
    [label]="'ACTIONS.CANCEL' | translate"
    icon="fal fa-times"
    styleClass="p-button-secondary"
    type="button"></p-button>
</div>
